import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
var _excluded = ["show", "onHide"];
import React, { useCallback } from 'react';
import BaseModal from 'react-overlays/Modal';
import { SettingsPanel } from './SettingsPanel';
import { modal, modalDialogWrapper, modalDialog, modalBackdrop } from './classNames';
import { jsx as _jsx } from "react/jsx-runtime";
export var renderBackdrop = function renderBackdrop(props) {
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, props), {}, {
    className: modalBackdrop
  }));
};
export function SettingsModal(_ref) {
  var show = _ref.show,
      onHide = _ref.onHide,
      rest = _objectWithoutProperties(_ref, _excluded);

  var onWrapperClick = useCallback(function (event) {
    if (event.target === event.currentTarget) {
      onHide();
    }
  }, [onHide]);
  return /*#__PURE__*/_jsx(BaseModal, {
    className: modal,
    renderBackdrop: renderBackdrop,
    show: show,
    onHide: onHide,
    children: /*#__PURE__*/_jsx("div", {
      className: modalDialogWrapper,
      onClick: onWrapperClick,
      role: "button",
      tabIndex: 0,
      children: /*#__PURE__*/_jsx("div", {
        className: modalDialog,
        children: /*#__PURE__*/_jsx(SettingsPanel, _objectSpread(_objectSpread({}, rest), {}, {
          handleClose: onHide
        }))
      })
    })
  });
}